import {AthubRestResource} from "@/api/rest";
import {DCIM_SERVER} from "@/api";
import {addParamsToUrl, athubAxios} from "@/util";

const equipment = new AthubRestResource({server: DCIM_SERVER, resource: 'equipment'});

equipment.checkAssetCode = (assetCode, id) => {
    return equipment.handlePromise(athubAxios.get(addParamsToUrl(`${DCIM_SERVER}/equipment/check/asset-code`, {
        assetCode: assetCode, id: id
    })));
};

equipment.asyncGenerateExcel = (search) => {
    return equipment.handlePromise(athubAxios.post(`${DCIM_SERVER}/equipment/excel/gen/async`, search));
};

equipment.existsExcel = (filepath) => {
    return equipment.handlePromise(athubAxios.get(addParamsToUrl(`${DCIM_SERVER}/equipment/excel/exists`, {
        filepath: filepath,
    })));
};

equipment.downloadExcel = (filepath) => {
    return athubAxios.download(addParamsToUrl(`${DCIM_SERVER}/equipment/excel/gen`, {
        filepath: filepath,
    }), '设备信息.xlsx');
};

equipment.getEquipmentTypeMemos = () => {
    return equipment.handlePromise(athubAxios.get(`${DCIM_SERVER}/equipment/type-memo/all`));
};

export default equipment;
